import { useLayoutEffect, useState } from "react"
import Axios from "axios"

import Loading from "../loading/loading"

import fieldStyle from "./field.module.css"
import managerStyle from "manager/manager.module.css"
import EventFieldMaker from "manager/omega/form/EventFieldMaker"


export default function Field() {

    const fieldToggle = window.EventManager.fieldToggle
    const Set_fieldToggle = window.EventManager.Set_fieldToggle

    const [fieldLoading, Set_fieldLoading] = useState(true)

    const [fieldList, Set_fieldList] = useState([])

    useLayoutEffect(() => {
        if(fieldLoading === true) {
            Set_fieldLoading(false)
        }
    }, [fieldToggle])

    async function field_save() {
        const result = await Axios
                        .post('/event/field/save', {
                        })
        console.log(result)
    }

    async function field_add() {
    }

    return(
        <div
            id="field"
            className={fieldStyle['fieldWrap']}
            style={{
                display: fieldToggle ? 'flex' : 'none'
            }}
        >
            <Loading
                loading={fieldLoading}
            ></Loading>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                    }}
                >
                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['primary']}
                        `}
                        style={{
                            width: "max-content",
                            height: "30px",
                            paddingInline: "10px",
                            marginRight: "10px"
                        }}
                        onClick={() => field_save()}
                    >저장</button>

                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['dark']}
                        `}
                        style={{
                            width: "max-content",
                            height: "30px",
                            paddingInline: "10px",
                            marginRight: "10px"
                        }}
                    >항목 추가</button>
                </div>

                <button
                    type="button"
                    className={`
                        ${managerStyle['button']}
                        ${managerStyle['secondary']}
                    `}
                    style={{
                        width: "70px",
                        height: "30px"
                    }}
                    onClick={() => Set_fieldToggle(false)}
                >닫기</button>
            </div>

            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto"
                }}
            >
                {fieldList
                .map((value, index) => {
                    <div>하하하</div>
                    // <EventFieldMaker
                    //     field={value}
                    // />
                })}
            </div>
        </div>
    )
}